import {Flow} from 'flow-to-typescript-codemod';
// @ts-nocheck
import * as React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-datepicker'. '/Users/diwaker/SpacedOut/ui-server/node_modules/react-datepicker/dist/index.js' implicitly has an 'any' type.
import DatePicker from 'react-datepicker';
import uniqueId from 'lodash/uniqueId';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import './date-picker-override.css';
import css from './date-picker.css';

import {classify} from 'src/utils/index';

import CalendarIcon from 'src/images/calendar-icon.svg';


type DatePickerProps = {
  className?: string;
  // @ts-expect-error TS2304
  defaultValue?: moment$Moment | null;
  // @ts-expect-error TS2304
  onChange?: (e?: moment$Moment | null | undefined) => void;
  // @ts-expect-error TS2304
  selected?: moment$Moment | null;
  disabled?: boolean;
};

export default class extends React.Component<
  DatePickerProps &
    Omit<
      Omit<
        Flow.ComponentProps<typeof DatePicker>,
        | 'id'
        | 'selected'
        | 'dateFormat'
        | 'fixedHeight'
        | 'onChange'
        | 'ref'
        | 'onClickOutside'
        | 'minDate'
        | 'maxDate'
        | 'disabled'
      >,
      keyof DatePickerProps
    >,
  {
    // @ts-expect-error TS2304
    value: moment$Moment | null | undefined;
    elementId: string;
    mounted: boolean;
  }
> {
  // @ts-expect-error TS2564
  handleChange: (value?: moment$Moment | null | undefined) => void;

  constructor(props: DatePickerProps) {
    super(props);

    this.state = {
      value: props.defaultValue || null,
      elementId: uniqueId('date-picker'),
      mounted: false,
    };
  }
  pickerRef = null;

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<DatePickerProps & Omit<Omit<any, "ref" | "disabled" | "id" | "selected" | "dateFormat" | "fixedHeight" | "onChange" | "onClickOutside" | "minDate" | "maxDate">, keyof DatePickerProps>, { ...; }, any>'.
  componentDidMount() {
    this.setState({mounted: true});
  }

  // @ts-expect-error TS2304
  _handleChange(value?: moment$Moment | null) {
    this.setState({value});
  }
  // @ts-expect-error - TS2300 - Duplicate identifier 'handleChange'.
  handleChange = this._handleChange.bind(this);

  _handleClickOutside() {
    // @ts-expect-error - TS2531 - Object is possibly 'null'.
    this.pickerRef.cancelFocusInput();
  }
  handleClickOutside = this._handleClickOutside.bind(this);

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<DatePickerProps & Omit<Omit<any, "ref" | "disabled" | "id" | "selected" | "dateFormat" | "fixedHeight" | "onChange" | "onClickOutside" | "minDate" | "maxDate">, keyof DatePickerProps>, { ...; }, any>'.
  render() {
    if (!this.state.mounted) {
      return null;
    }

    const {className, selected, onChange, minDate, maxDate, disabled, ...rest} =
      this.props;

    const handleChange = onChange || this.handleChange;
    return (
      <div
        className={classify(css.datePicker, className, {
          [css.disabled]: disabled,
        })}
      >
        <DatePicker
          id={this.state.elementId}
          selected={selected?.toDate() || this.state.value?.toDate()}
          dateFormat={'yyyy-MM-dd'}
          fixedHeight={true}
          // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
          onChange={(value) => handleChange(moment(value))}
          // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
          ref={(node) => {
            this.pickerRef = node;
          }}
          onClickOutside={this.handleClickOutside}
          minDate={minDate?.toDate()}
          maxDate={maxDate?.toDate()}
          disabled={disabled}
          {...rest}
        />
        <label htmlFor={this.state.elementId} className={css.label}>
          <CalendarIcon />
        </label>
      </div>
    );
  }
}
